module.exports = __webpack_public_path__ + "static/media/Logo 2Kitchens.2daa8014.png";


//////////////////
// WEBPACK FOOTER
// ./src/mockAPI/images/Logo 2Kitchens.png
// module id = 259
// module chunks = 0